// import React, { useEffect, useState } from "react";
// import useApi from "../../CustomHooks/useApi";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const LedgerReport = ({ mid }) => {
//     const { callApi: ledgerreport } = useApi("/ledger/retailer", "GET");
//     const [downloading, setDownloading] = useState(false);



//     const formatDate = (date) => {
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, "0");
//         const day = String(date.getDate()).padStart(2, "0");

//         return `${year}-${month}-${day}`;
//     };

//     const today = formatDate(new Date());

//     const [history, setHistory] = useState([]);
//     const [page, setPage] = useState(0);
//     const [size] = useState(20);

//     const [totalPages, setTotalPages] = useState(0);
//     const [totalElements, setTotalElements] = useState(0);

//     const [loading, setLoading] = useState(false);

//     const [fromDate, setFromDate] = useState(today);
//     const [toDate, setToDate] = useState(today);

//     // ✅ FETCH API
//     const fetchLedger = async (targetPage = 0, loadMore = false) => {
//         if (!mid) return;

//         setLoading(true);

//         let query = `?bid=${mid}&page=${targetPage}&size=${size}&scope=self`;

//         if (fromDate) query += `&fromDate=${fromDate}`;
//         if (toDate) query += `&toDate=${toDate}`;

//         try {
//             const res = await ledgerreport(null, query);

//             const data = (res?.content || []).filter(Boolean);

//             setTotalPages(res?.totalPages || 0);
//             setTotalElements(res?.totalElements || 0);

//             setHistory((prev) =>
//                 loadMore ? [...prev, ...data] : data
//             );

//             setPage(targetPage);
//         } catch (err) {
//             console.error(err);
//             if (!loadMore) setHistory([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ✅ INITIAL LOAD
//     useEffect(() => {
//         fetchLedger(0);
//     }, [mid]);

//     // ✅ AMOUNT FORMAT
//     const formatAmount = (value = 0, type) => {
//         if (type === "CREDIT" || type === "Approved") {
//             return <span className="text-green-700 font-semibold">₹{value.toFixed(2)}</span>;
//         }
//         if (type === "DEBIT") {
//             return <span className="text-red-600 font-semibold">₹{value.toFixed(2)}</span>;
//         }
//         if (type === "REFUND") {
//             return (
//                 <span className="text-yellow-700 bg-yellow-50 px-2 py-0.5 rounded font-semibold">
//                     ₹{value.toFixed(2)}
//                 </span>
//             );
//         }
//         return `₹${value}`;
//     };

//     // const downloadLedgerExcel = async () => {
//     //     if (!mid) return;

//     //     try {
//     //         let query = `?bid=${mid}&page=0&size=${totalElements}&scope=self`;

//     //         if (fromDate) query += `&fromDate=${fromDate}`;
//     //         if (toDate) query += `&toDate=${toDate}`;

//     //         const res = await ledgerreport(null, query);
//     //         const data = res?.content || [];

//     //         if (!data.length) {
//     //             alert("No data to download");
//     //             return;
//     //         }

//     //         // ✅ Format data (important)
//     //         const formattedData = data.map((row) => ({
//     //             "Txn ID": row.txnId,
//     //             "Txn Date": new Date(row.txnDate).toLocaleString("en-IN"),
//     //             "Shop Name": row.shopName,
//     //             "Narration": row.narration,
//     //             "Type": row.txnType,
//     //             "Txn Amount": row.txnAmount,
//     //             "Net Amount": row.netAmount,
//     //             "Charges": row.charges,
//     //             "TDS": row.tds,
//     //             "Cashback": row.cashback,
//     //             "Commission": row.commission,
//     //             "Balance": row.balance,
//     //         }));

//     //         // ✅ Convert to worksheet
//     //         const worksheet = XLSX.utils.json_to_sheet(formattedData);

//     //         // ✅ Create workbook
//     //         const workbook = XLSX.utils.book_new();
//     //         XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger");

//     //         // ✅ Generate Excel file
//     //         const excelBuffer = XLSX.write(workbook, {
//     //             bookType: "xlsx",
//     //             type: "array",
//     //         });

//     //         const file = new Blob([excelBuffer], {
//     //             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     //         });

//     //         saveAs(file, `Ledger_${fromDate}_to_${toDate}.xlsx`);

//     //     } catch (err) {
//     //         console.error(err);
//     //         alert("Excel download failed");
//     //     }
//     // };

//     const downloadLedgerExcel = async () => {
//         if (!mid) return;
//         setDownloading(true)

//         try {
//             let allData = [];
//             let currentPage = 0;
//             let totalPagesLocal = 1;

//             while (currentPage < totalPagesLocal) {

//                 let query = `?bid=${mid}&page=${currentPage}&size=${size}&scope=self`;

//                 if (fromDate) query += `&fromDate=${fromDate}`;
//                 if (toDate) query += `&toDate=${toDate}`;

//                 const res = await ledgerreport(null, query);

//                 const data = res?.content || [];

//                 allData = [...allData, ...data];

//                 totalPagesLocal = res?.totalPages || 1;

//                 currentPage++;
//             }

//             if (!allData.length) {
//                 alert("No data to download");
//                 return;
//             }

//             const formattedData = allData.map((row) => ({
//                 "Txn ID": row.txnId,
//                 "Txn Date": new Date(row.txnDate).toLocaleString("en-IN"),
//                 "Shop Name": row.shopName,
//                 "Narration": row.narration,
//                 "Type": row.txnType,
//                 "Txn Amount": row.txnAmount,
//                 "Net Amount": row.netAmount,
//                 "Charges": row.charges,
//                 "TDS": row.tds,
//                 "Cashback": row.cashback,
//                 "Commission": row.commission,
//                 "Balance": row.balance,
//             }));

//             const worksheet = XLSX.utils.json_to_sheet(formattedData);
//             const workbook = XLSX.utils.book_new();

//             XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger");

//             const excelBuffer = XLSX.write(workbook, {
//                 bookType: "xlsx",
//                 type: "array",
//             });

//             const file = new Blob([excelBuffer], {
//                 type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//             });

//             saveAs(file, `Ledger_${fromDate}_to_${toDate}.xlsx`);

//         } catch (err) {
//             console.error(err);
//             alert("Excel download failed");
//         }
//         finally {
//             setDownloading(false)
//         }
//     };


//     return (
//         <div className="bg-white rounded-xl shadow border p-5">

//             {/* HEADER */}
//             <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-4">
//                 <h3 className="font-semibold text-lg text-[#0A2A4F]">
//                     📒 Ledger Report
//                 </h3>

//                 <div className="text-sm text-gray-500">
//                     Total Records: <b>{totalElements}</b>
//                 </div>
//             </div>

//             {/* 🔥 DATE FILTER */}
//             <div className="grid md:grid-cols-4 gap-3 mb-4">

//                 {/* FROM DATE */}
//                 <input
//                     type="date"
//                     value={fromDate}
//                     max={today}
//                     onChange={(e) => {
//                         const selected = e.target.value;
//                         setFromDate(selected);
//                         if (toDate < selected) {
//                             setToDate(selected);
//                         }
//                     }}
//                     className="border rounded-lg px-3 py-2"
//                 />

//                 {/* TO DATE LOCKED */}
//                 <input
//                     type="date"
//                     value={toDate}
//                     min={fromDate}
//                     max={today}
//                     onChange={(e) => setToDate(e.target.value)}
//                     className="border rounded-lg px-3 py-2"
//                 />

//                 {/* APPLY */}
//                 {/* <button
//                     onClick={() => fetchLedger(0)}
//                     className="bg-blue-600 text-white rounded-lg px-4 py-2"
//                 >
//                     Apply
//                 </button> */}

//                 <button
//                     onClick={() => fetchLedger(0)}
//                     disabled={loading}
//                     className="bg-blue-600 text-white rounded-lg px-4 py-2 flex items-center justify-center gap-2 disabled:opacity-50"
//                 >
//                     {loading ? (
//                         <>
//                             <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
//                             Loading...
//                         </>
//                     ) : (
//                         "Apply"
//                     )}
//                 </button>


//                 {/* RESET */}
//                 <button
//                     onClick={() => {
//                         setFromDate(today);
//                         setToDate(today);
//                         setTimeout(() => fetchLedger(0), 0);
//                     }}
//                     className="bg-gray-300 rounded-lg px-4 py-2"
//                 >
//                     Reset
//                 </button>
//                 {/* 
//                 <button
//                     onClick={downloadLedgerExcel}
//                     className="bg-green-600 text-white px-4 py-2 rounded-lg"
//                 >
//                     Download Excel
//                 </button> */}

//                 <button
//                     onClick={downloadLedgerExcel}
//                     disabled={downloading}
//                     className="bg-green-600 text-white px-4 py-2 rounded-lg flex items-center justify-center gap-2 disabled:opacity-50"
//                 >
//                     {downloading ? (
//                         <>
//                             <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
//                             Downloading...
//                         </>
//                     ) : (
//                         "Download Excel"
//                     )}
//                 </button>

//             </div>

//             {/* TABLE */}
//             <div className="w-full overflow-auto max-h-[65vh] border rounded-xl">
//                 <table className="w-full text-sm border-collapse">

//                     <thead className="sticky top-0 bg-gray-100 z-10">
//                         <tr>
//                             {[
//                                 "Txn ID",
//                                 "Txn Date",
//                                 "Shop",
//                                 "Narration",
//                                 "CR",
//                                 "DR",
//                                 "RR",
//                                 "Charges",
//                                 "TDS",
//                                 "Net Amount",
//                                 "Cashback",
//                                 "Commission",
//                                 "Balance",
//                             ].map((h) => (
//                                 <th key={h} className="px-3 py-2 border text-left">
//                                     {h}
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {history.length > 0 ? (
//                             history.map((row, i) => (
//                                 <tr key={i} className="hover:bg-gray-50">

//                                     <td className="px-3 py-2 border">{row.txnId}</td>
//                                     <td className="px-3 py-2 border">{new Date(row.txnDate).toLocaleString("en-IN")}</td>
//                                     <td className="px-3 py-2 border">{row.shopName}</td>
//                                     <td className="px-3 py-2 border">{row.narration}</td>

//                                     {/* CR */}
//                                     <td className="px-3 py-2 border">
//                                         {(row.txnType === "CREDIT" || row.txnType === "Approved")
//                                             ? `₹${row.netAmount?.toFixed(2)}`
//                                             : "-"}
//                                     </td>

//                                     {/* DR */}
//                                     <td className="px-3 py-2 border">
//                                         {row.txnType === "DEBIT"
//                                             ? `₹${row.netAmount?.toFixed(2)}`
//                                             : "-"}
//                                     </td>

//                                     {/* RR */}
//                                     <td className="px-3 py-2 border">
//                                         {row.txnType === "REFUND"
//                                             ? `₹${row.txnAmount?.toFixed(2)}`
//                                             : "-"}
//                                     </td>

//                                     <td className="px-3 py-2 border">₹{row.charges || 0}</td>
//                                     <td className="px-3 py-2 border">₹{row.tds || 0}</td>

//                                     {/* NET */}
//                                     <td className="px-3 py-2 border">
//                                         {formatAmount(row.txnAmount || 0, row.txnType)}
//                                     </td>

//                                     <td className="px-3 py-2 border">₹{row.cashback || 0}</td>
//                                     <td className="px-3 py-2 border">₹{row.commission || 0}</td>
//                                     <td className="px-3 py-2 border font-semibold">
//                                         ₹{row.balance || 0}
//                                     </td>

//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="13" className="text-center py-6 text-gray-500">
//                                     No Transactions Found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>

//                 </table>
//             </div>

//             {/* LOAD MORE */}
//             <div className="flex justify-between items-center mt-4">

//                 <div className="text-sm text-gray-500">
//                     Page: {page + 1} / {totalPages}
//                 </div>

//                 {page + 1 < totalPages && (
//                     <button
//                         onClick={() => fetchLedger(page + 1, true)}
//                         disabled={loading}
//                         className="px-5 py-2 bg-[#0A2A4F] text-white rounded-lg hover:bg-[#123b6e]"
//                     >
//                         {loading ? "Loading..." : "Load More"}
//                     </button>
//                 )}
//             </div>

//         </div>
//     );
// };

// export default LedgerReport;


import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const LedgerReport = ({ mid }) => {
    const { callApi: ledgerreport } = useApi("/ledger/retailer", "GET");
    const [downloading, setDownloading] = useState(false);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const today = formatDate(new Date());

    const [history, setHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [size] = useState(20);

    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const [loading, setLoading] = useState(false);

    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);

    // ✅ NEW: State for frontend-only search
    const [searchTxnId, setSearchTxnId] = useState("");

    // ✅ FETCH API (Unchanged, it still fetches all data based on date)
    const fetchLedger = async (targetPage = 0, loadMore = false) => {
        if (!mid) return;

        setLoading(true);

        let query = `?bid=${mid}&page=${targetPage}&size=${size}&scope=self`;

        if (fromDate) query += `&fromDate=${fromDate}`;
        if (toDate) query += `&toDate=${toDate}`;

        try {
            const res = await ledgerreport(null, query);

            const data = (res?.content || []).filter(Boolean);

            setTotalPages(res?.totalPages || 0);
            setTotalElements(res?.totalElements || 0);

            setHistory((prev) =>
                loadMore ? [...prev, ...data] : data
            );

            setPage(targetPage);
        } catch (err) {
            console.error(err);
            if (!loadMore) setHistory([]);
        } finally {
            setLoading(false);
        }
    };

    // ✅ INITIAL LOAD
    useEffect(() => {
        fetchLedger(0);
    }, [mid]);

    // ✅ AMOUNT FORMAT
    const formatAmount = (value = 0, type) => {
        if (type === "CREDIT" || type === "Approved") {
            return <span className="text-green-700 font-semibold">₹{value.toFixed(2)}</span>;
        }
        if (type === "DEBIT") {
            return <span className="text-red-600 font-semibold">₹{value.toFixed(2)}</span>;
        }
        if (type === "REFUND") {
            return (
                <span className="text-yellow-700 bg-yellow-50 px-2 py-0.5 rounded font-semibold">
                    ₹{value.toFixed(2)}
                </span>
            );
        }
        return `₹${value}`;
    };

    const downloadLedgerExcel = async () => {
        if (!mid) return;
        setDownloading(true)

        try {
            let allData = [];
            let currentPage = 0;
            let totalPagesLocal = 1;

            while (currentPage < totalPagesLocal) {

                let query = `?bid=${mid}&page=${currentPage}&size=${size}&scope=self`;

                if (fromDate) query += `&fromDate=${fromDate}`;
                if (toDate) query += `&toDate=${toDate}`;

                const res = await ledgerreport(null, query);

                const data = res?.content || [];

                allData = [...allData, ...data];

                totalPagesLocal = res?.totalPages || 1;

                currentPage++;
            }

            if (!allData.length) {
                alert("No data to download");
                return;
            }

            const formattedData = allData.map((row) => ({
                "Txn ID": row.txnId,
                "Txn Date": new Date(row.txnDate).toLocaleString("en-IN"),
                "Shop Name": row.shopName,
                "Narration": row.narration,
                "Type": row.txnType,
                "Txn Amount": row.txnAmount,
                "Net Amount": row.netAmount,
                "Charges": row.charges,
                "TDS": row.tds,
                "Cashback": row.cashback,
                "Commission": row.commission,
                "Balance": row.balance,
            }));

            const worksheet = XLSX.utils.json_to_sheet(formattedData);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const file = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(file, `Ledger_${fromDate}_to_${toDate}.xlsx`);

        } catch (err) {
            console.error(err);
            alert("Excel download failed");
        }
        finally {
            setDownloading(false)
        }
    };

    // ✅ NEW: Filter the history array based on the search input
    // This happens instantly on the frontend without calling the API
    const filteredHistory = history.filter((row) =>
        row.txnId?.toLowerCase().includes(searchTxnId.toLowerCase().trim())
    );


    return (
        <div className="bg-white rounded-xl shadow border p-5">

            {/* HEADER */}
            <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-4">
                <h3 className="font-semibold text-lg text-[#0A2A4F]">
                    📒 Ledger Report
                </h3>

                <div className="text-sm text-gray-500">
                    Total Records: <b>{totalElements}</b>
                </div>
            </div>

            {/* 🔥 DATE & SEARCH FILTER */}
            {/* ✅ NEW: Adjusted grid columns to lg:grid-cols-6 to fit the new search input */}
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-4">

                {/* ✅ NEW: Instant Frontend Search Input */}
                <input
                    type="text"
                    placeholder="Search Txn ID..."
                    value={searchTxnId}
                    onChange={(e) => setSearchTxnId(e.target.value)}
                    className="border rounded-lg px-3 py-2 w-full outline-none focus:border-blue-500"
                />

                {/* FROM DATE */}
                <input
                    type="date"
                    value={fromDate}
                    max={today}
                    onChange={(e) => {
                        const selected = e.target.value;
                        setFromDate(selected);
                        if (toDate < selected) {
                            setToDate(selected);
                        }
                    }}
                    className="border rounded-lg px-3 py-2"
                />

                {/* TO DATE LOCKED */}
                <input
                    type="date"
                    value={toDate}
                    min={fromDate}
                    max={today}
                    onChange={(e) => setToDate(e.target.value)}
                    className="border rounded-lg px-3 py-2"
                />

                {/* APPLY */}
                <button
                    onClick={() => fetchLedger(0)}
                    disabled={loading}
                    className="bg-blue-600 text-white rounded-lg px-4 py-2 flex items-center justify-center gap-2 disabled:opacity-50"
                >
                    {loading ? (
                        <>
                            <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                            Loading...
                        </>
                    ) : (
                        "Apply"
                    )}
                </button>


                {/* RESET */}
                <button
                    onClick={() => {
                        setFromDate(today);
                        setToDate(today);
                        setSearchTxnId(""); // ✅ NEW: Clear search on reset
                        setTimeout(() => fetchLedger(0), 0);
                    }}
                    className="bg-gray-300 rounded-lg px-4 py-2"
                >
                    Reset
                </button>

                <button
                    onClick={downloadLedgerExcel}
                    disabled={downloading}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg flex items-center justify-center gap-2 disabled:opacity-50"
                >
                    {downloading ? (
                        <>
                            <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                            Downloading...
                        </>
                    ) : (
                        "Download Excel"
                    )}
                </button>

            </div>

            {/* TABLE */}
            <div className="w-full overflow-auto max-h-[65vh] border rounded-xl">
                <table className="w-full text-sm border-collapse">

                    <thead className="sticky top-0 bg-gray-100 z-10">
                        <tr>
                            {[
                                "Txn ID",
                                "Txn Date",
                                "Shop",
                                "Narration",
                                "CR",
                                "DR",
                                "RR",
                                "Charges",
                                "TDS",
                                "Net Amount",
                                "Cashback",
                                "Commission",
                                "Balance",
                            ].map((h) => (
                                <th key={h} className="px-3 py-2 border text-left">
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {/* ✅ NEW: Map over `filteredHistory` instead of `history` */}
                        {filteredHistory.length > 0 ? (
                            filteredHistory.map((row, i) => (
                                <tr key={i} className="hover:bg-gray-50">

                                    <td className="px-3 py-2 border">{row.txnId}</td>
                                    <td className="px-3 py-2 border">{new Date(row.txnDate).toLocaleString("en-IN")}</td>
                                    <td className="px-3 py-2 border">{row.shopName}</td>
                                    <td className="px-3 py-2 border">{row.narration}</td>

                                    {/* CR */}
                                    <td className="px-3 py-2 border">
                                        {(row.txnType === "CREDIT" || row.txnType === "Approved")
                                            ? `₹${row.netAmount?.toFixed(2)}`
                                            : "-"}
                                    </td>

                                    {/* DR */}
                                    <td className="px-3 py-2 border">
                                        {row.txnType === "DEBIT"
                                            ? `₹${row.netAmount?.toFixed(2)}`
                                            : "-"}
                                    </td>

                                    {/* RR */}
                                    <td className="px-3 py-2 border">
                                        {row.txnType === "REFUND"
                                            ? `₹${row.txnAmount?.toFixed(2)}`
                                            : "-"}
                                    </td>

                                    <td className="px-3 py-2 border">₹{row.charges || 0}</td>
                                    <td className="px-3 py-2 border">₹{row.tds || 0}</td>

                                    {/* NET */}
                                    <td className="px-3 py-2 border">
                                        {formatAmount(row.txnAmount || 0, row.txnType)}
                                    </td>

                                    <td className="px-3 py-2 border">₹{row.cashback || 0}</td>
                                    <td className="px-3 py-2 border">₹{row.commission || 0}</td>
                                    <td className="px-3 py-2 border font-semibold">
                                        ₹{row.balance || 0}
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="13" className="text-center py-6 text-gray-500">
                                    No Transactions Found
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>

            {/* LOAD MORE */}
            {/* ✅ NEW: Hide "Load More" if user is actively searching, to prevent confusion */}
            {!searchTxnId && (
                <div className="flex justify-between items-center mt-4">

                    <div className="text-sm text-gray-500">
                        Page: {page + 1} / {totalPages}
                    </div>

                    {page + 1 < totalPages && (
                        <button
                            onClick={() => fetchLedger(page + 1, true)}
                            disabled={loading}
                            className="px-5 py-2 bg-[#0A2A4F] text-white rounded-lg hover:bg-[#123b6e]"
                        >
                            {loading ? "Loading..." : "Load More"}
                        </button>
                    )}
                </div>
            )}

        </div>
    );
};

export default LedgerReport;